import { browser } from '$app/environment';
import { experimentService } from '$lib/services/experiments/client';
import { getEnvironment } from '$lib/utils/environment';
import { setGlobalStore } from '$lib/stores/app/store';
import { qualifyExperiments } from '$lib/services/experiments';
import { AnalyticsService } from '$lib/services/analytics';
import { QUERY_PARAM_KEYS } from '$lib/utils/constants';
import { setMeta } from '$lib/stores/app/actions';
import { getDeviceId, initializeDeviceId } from '$lib/utils/device-id';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/sveltekit';

export const prerender = true;
export const trailingSlash = 'always';

/** @type {import('./$types').LayoutLoad} */
export async function load({ url, data }) {
	// Browser load only runs client-side initialization (uses js-cookie)
	// Both can coexist: server handles SSR, browser handles client-side
	if (browser) {
		// Initialize URL-based values BEFORE any code that might need them
		// This ensures they're available for route conditions and other early initialization
		const params = url.searchParams;
		const linkFromAppPlatform = params.get('linkFromAppPlatform');
		if (linkFromAppPlatform) {
			setGlobalStore({ linkFromAppPlatform });
		}

		// Use isFirstTimeVisit from server load if available (more accurate)
		// Otherwise fall back to checking before initializing
		// @ts-ignore - data.isFirstTimeVisit comes from server load
		const isFirstTimeVisit = data?.isFirstTimeVisit ?? !getDeviceId();
		setGlobalStore({ isFirstTimeVisit });

		// Initialize device ID once per app load
		// This ensures device ID exists for all subsequent read operations
		initializeDeviceId();

		// Initialize meta values (including inApp detection) BEFORE route conditions run
		// Route conditions depend on config.meta.inApp, so this must happen early
		const isLinkFromEmail = params.get(QUERY_PARAM_KEYS.EMAIL_CLICK) ? 'true' : 'false';
		try {
			await setMeta({
				...Cookies.get(),
				acquisitionSource: AnalyticsService.getSourceTag() ?? '',
				deviceId: getDeviceId() ?? '',
				isLinkFromEmail: isLinkFromEmail
			});
		} catch (error) {
			Sentry.captureException(error, {
				extra: {
					action: 'Error: Layout.load setMeta'
				}
			});
		}

		await qualifyExperiments();
		setGlobalStore({ environment: getEnvironment() });
		await experimentService.initializeExperiments();

		// Ensure product experience is set from URL before conditions resolve
		AnalyticsService.setProductExperienceFromQuery();
	}
	return {};
}